/**
 * Records a normalized RUM page view whenever the route changes. Mounted once
 * near the app root. Uses React Router v5's `useLocation` (the portal is on
 * RR v5 — no data router). Only the pathname is used; query/hash are stripped
 * by the normalizer, so identifiers in `?patient-id=` never reach RUM.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { recordNormalizedPageView } from './rumClient';

export function useRumPageView(): void {
  const location = useLocation();
  useEffect(() => {
    recordNormalizedPageView(location.pathname);
  }, [location.pathname]);
}
